import { BaseApi } from '@/main/baseApi';

import { API_ND_AREA, NAME } from './constants';

class DealerProvider extends BaseApi {
	constructor() {
		super(API_ND_AREA, NAME);
	}
}
export const apiProvider = new DealerProvider();
